export const listMenuBrand = [
    {
        id:1,
        name:'apple',
        url:'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/smartwatch/logo01.png',
    },
    {
        id:2,
        name:'samsung',
        url:'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/smartwatch/logo02b.png',
    },
    {
        id:3,
        name:'garmin',
        url:'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/smartwatch/logo03.png',
    },
    {
        id:4,
        name:'befit',
        url:'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/smartwatch/logo04-1.png',
    },
    {
        id:5,
        name:'xiaomi',
        url:'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/smartwatch/logo05.png',
    },
    {
        id:6,
        name:'kidcare',
        url:'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/smartwatch/logo06.png',
    },
    {
        id:7,
        name:'amazfit',
        url:'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/smartwatch/logo07.png',
    },
    {
        id:8,
        name:'oppo',
        url:'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/smartwatch/logo08.png',
    },
]

export const listMenuCate = [
    {
        id:1,
        name:'deal',
        title:'Deal Sốc',
        url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
    },
    {
        id:2,
        name:'fashion',
        title:'Thời Trang',
        url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
    },
    {
        id:3,
        name:'utility',
        title:'Tiện Ích',
        url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
    },
    {
        id:4,
        name:'sport',
        title:'Thể Thao',
        url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
    },
    {
        id:5,
        name:'children',
        title:'Trẻ Em',
        url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
    },
    {
        id:6,
        name:'accessory',
        title:'Phụ Kiện',
        url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
    },
]


export const list_product_smartWatch = [
    {
        id:1,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        online:'Online giá rẻ',
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:2,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        online:'Online giá rẻ',
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:3,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:1,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:4,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:5,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:4,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:6,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:7,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:8,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:2,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:9,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:10,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:11,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:12,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:13,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:14,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:15,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:16,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:17,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:18,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:19,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:20,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:21,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:22,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:23,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:24,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:25,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:26,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:27,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:28,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:29,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:30,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:31,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:32,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:33,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:34,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:35,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:36,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
]

export const sliders_smart_watch = [
    {
        id:1,
        title: 'Lorem',
        linkTo:'/dong-ho-thong-minh-gia-soc',
        url: 'https://cdn.tgdd.vn/2022/07/banner/lhwatch-800-200-800x200-1.png'
    },
    {
        id:2,
        title: 'Lorem',
        linkTo:'/dong-ho-thong-minh-apple-watch-series-7',
        url: 'https://cdn.tgdd.vn/2022/07/banner/800-200-800x200-79.png'
    
    },
    {
        id:3,
        title: 'Lorem',
        linkTo:'/dong-ho-thong-minh-galaxy-watch-4',
        url: 'https://cdn.tgdd.vn/2022/07/banner/800-X-200--2---1--800x200.png'
    
    },
    {
        id:4,
        title: 'Lorem',
        linkTo:'/dong-ho-thong-minh-xiaomi',
        url: 'https://cdn.tgdd.vn/2022/07/banner/800-200-800x200-144.png'
    
    },
   
]


export const block_fashion_menu_top = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Dưới 1 triệu',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Apple',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Samsung',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Xiaomi',
        cateId: 7,
        manufactureId:10,
    },  
    {
        title:'Amazfit',
        cateId: 7,
        manufactureId:10,
    },  
]

export const block_utility_menu_top = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Chống nước',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Có nghe gọi',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Đo nồng độ Oxy',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Bộ nhớ lưu trữ nhạc',
        cateId: 7,
        manufactureId:10,
    },  
   
]



export const block_sport_menu_top = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Chạy bộ',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Bơi lội',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Đạp xe',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Thể thao đa môn',
        cateId: 7,
        manufactureId:10,
    },  
    {
        title:'Garmin',
        cateId: 7,
        manufactureId:10,
    },  
    {
        title:'Suunto',
        cateId: 7,
        manufactureId:10,
    },  
]


export const block_watch_chain_menu_top = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Apple',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Samsung',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Mi Band',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Dây silicon',
        cateId: 7,
        manufactureId:10,
    },  
    {
        title:'Dây da',
        cateId: 7,
        manufactureId:10,
    },  
]


export const festival_sale_menu_top = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Apple',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Samsung',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'BeFit',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Định vị trẻ em',
        cateId: 7,
        manufactureId:10,
    },  
   
]



export const box_filter_fest = [
    {
       title: 'Nổi bật'
    },
    {

       title: '% giảm nhiều'
    },
    {

       title:  'Giá thấp đến cao'
    },
]


export const list_box_filter_xiaomi = [
    {
        id:1,
        title: 'Xiaomi',
        name:'brand',
        dropDown: [
            {
                id:1,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Apple7077-b26-220x48.png'
            },
            {
                id:2,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-5.png'
            },
            {
                id:3,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14.png'
            },
            {
                id:4,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Garmin7077-b_13.png'
            },
            {
                id:5,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/logo-befit-220x48-1.png'
            },
            {
                id:6,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/logoamazfit-220x48-1.png'
            },
            {
                id:7,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Kidcare7077-b_5.jpg'
            },
            {
                id:8,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Masstel7077-b_57.jpg'
            },
            {
                id:9,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Oppo7077-b_28.jpg'
            },
            {
                id:10,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Realme7077-b_28.jpg'
            },
            {
                id:11,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Abardeen7077-b_25.jpg'
            },
            {
                id:12,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Suunto7077-b_14.png'
            },
            {
                id:13,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-11.png'
            },
            {
                id:14,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/itellogo-220x48-1.png'
            },
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content:'Dưới 1 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 1 - 2 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 4 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 4 - 7 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 10 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 10 - 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:3,
        title: 'Thời trang sành điệu',
        name:'fashion',
        dropDown: [
            {
                content:'Thời trang sành điệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Thể thao chuyên nghiệp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Định vị trẻ em',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vòng đeo tay thông minh',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:4,
        title: 'Môn thể thao',
        name:'sport-subject',
        dropDown: [
            {
                content:'Chạy bộ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bơi lộ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đạp xe',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bộ môn phối hợp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Yoga',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bóng đá',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Golf',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:5,
        title: 'Mặt đồng hồ',
        name:'face-watch',
        dropDown: [
            {
                content:'Dới 40 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'40 - 42 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'42 - 45 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 45 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Chữ nhật',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vuông',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tròn',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:6,
        title: 'Thời lượng pin',
        name:'battery',
        dropDown: [
            {
                content:'Dưới 2 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 5 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 5 - 7 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 14 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 14 ngày',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:7,
        title: 'Kháng nước',
        name:'avoid-water',
        dropDown: [
            {
                content:'IP64 / 2 ATM (Rửa tay)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'IP67 / 3 ATM (Đi mưa)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'IP68 / 5 ATM (Tắm)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'5 ATM ISO 22810:2010 (Bơi)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'10 ATM (Lặn)',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:8,
        title: 'Theo dõi sức khỏe',
        name:'healthy',
        dropDown: [
            {
                content:'Đo lượng tiêu thụ oxy tối đa (VO2 max)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đo nồng độ oxy trong máu (SpO2)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tính quãng đường chạy',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tính lượng calories tiêu thụ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Theo dõi giấc ngủ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đo nhịp tim',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đếm số bước chân',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:9,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
                content:'Hỗ trợ eSIM',
                subCateId:1,
                manufactureId:2
            },
            {
                content:'Hỗ trợ SIM 4G/LTE',
                subCateId:1,
                manufactureId:2
            },
            {
                content:'Nghe gọi ngay trên đồng hồ',
                subCateId:1,
                manufactureId:2
            },
            {
                content:'Nhận cuộc gọi bằng đồng hồ',
                subCateId:1,
                manufactureId:2
            },
            {
                content:'Màn hình luôn hiển thị',
                subCateId:1,
                manufactureId:2
            },
            {
                content:'Sạc bằng năng lượng mặt trời',
                subCateId:1,
                manufactureId:2
            },
            {
                content:'Phát hiện té ngã',
                subCateId:1,
                manufactureId:2
            },
            {
                content:'Nghe nhạc',
                subCateId:1,
                manufactureId:2
            },
            {
                content:'Kết nối bluetooth với tai nghe',
                subCateId:1,
                manufactureId:2
            },
        ],
    },
    {
        id:10,
        title: 'Màu sắc',
        name:'color',
        dropDown: [
            {
                content:'Đen',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Hồng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Xanh dương',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trắng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đỏ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vàng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Xanh lá',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
]

export const list_box_filter_samsung = [
    {
        id:1,
        title: 'Samsung',
        name:'brand',
        dropDown: [
            {
                id:1,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Apple7077-b26-220x48.png'
            },
            {
                id:2,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-5.png'
            },
            {
                id:3,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14.png'
            },
            {
                id:4,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Garmin7077-b_13.png'
            },
            {
                id:5,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/logo-befit-220x48-1.png'
            },
            {
                id:6,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/logoamazfit-220x48-1.png'
            },
            {
                id:7,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Kidcare7077-b_5.jpg'
            },
            {
                id:8,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Masstel7077-b_57.jpg'
            },
            {
                id:9,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Oppo7077-b_28.jpg'
            },
            {
                id:10,
                img:'https://cdn.tgdd.vn/Brand/1/Realme7077-b_28.jpg'
            },
            {
                id:11,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Abardeen7077-b_25.jpg'
            },
            {
                id:12,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/Suunto7077-b_14.png'
            },
            {
                id:13,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-11.png'
            },
            {
                id:14,
                subCateId:1,
                manufactureId:2,
                img:'https://cdn.tgdd.vn/Brand/1/itellogo-220x48-1.png'
            },
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content:'Dưới 1 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 1 - 2 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 4 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 4 - 7 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 10 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 10 - 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:3,
        title: 'Thời trang sành điệu',
        name:'fashion',
        dropDown: [
            {
                content:'Thời trang sành điệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Thể thao chuyên nghiệp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Định vị trẻ em',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vòng đeo tay thông minh',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:4,
        title: 'Môn thể thao',
        name:'sport-subject',
        dropDown: [
            {
                content:'Chạy bộ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bơi lộ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đạp xe',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bộ môn phối hợp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Yoga',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bóng đá',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Golf',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:5,
        title: 'Mặt đồng hồ',
        name:'face-watch',
        dropDown: [
            {
                content:'Dới 40 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'40 - 42 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'42 - 45 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 45 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Chữ nhật',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vuông',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tròn'
            },
        ],
    },
    {
        id:6,
        title: 'Thời lượng pin',
        name:'battery',
        dropDown: [
            {
                content:'Dưới 2 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 5 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 5 - 7 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 14 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 14 ngày',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:7,
        title: 'Kháng nước',
        name:'avoid-water',
        dropDown: [
            {
                content:'IP64 / 2 ATM (Rửa tay)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'IP67 / 3 ATM (Đi mưa)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'IP68 / 5 ATM (Tắm)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'5 ATM ISO 22810:2010 (Bơi)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'10 ATM (Lặn)',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:8,
        title: 'Theo dõi sức khỏe',
        name:'healthy',
        dropDown: [
            {
                content:'Đo lượng tiêu thụ oxy tối đa (VO2 max)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đo nồng độ oxy trong máu (SpO2)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tính quãng đường chạy',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tính lượng calories tiêu thụ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Theo dõi giấc ngủ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đo nhịp tim',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đếm số bước chân',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:9,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
                content:'Hỗ trợ eSIM',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Hỗ trợ SIM 4G/LTE',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nghe gọi ngay trên đồng hồ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nhận cuộc gọi bằng đồng hồ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Màn hình luôn hiển thị',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Sạc bằng năng lượng mặt trời',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Phát hiện té ngã',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nghe nhạc',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Kết nối bluetooth với tai nghe',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:10,
        title: 'Màu sắc',
        name:'color-samsung',
        dropDown: [
            {
                content:'Đen',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Hồng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Xanh dương',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trắng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đỏ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vàng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Xanh lá',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
]
export const list_box_filter_apple = [
    {
        id:1,
        title: 'Apple',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/Apple7077-b26-220x48.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-5.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/Garmin7077-b_13.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/logo-befit-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:6,
                img:'https://cdn.tgdd.vn/Brand/1/logoamazfit-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:7,
                img:'https://cdn.tgdd.vn/Brand/1/Kidcare7077-b_5.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:8,
                img:'https://cdn.tgdd.vn/Brand/1/Masstel7077-b_57.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:9,
                img:'https://cdn.tgdd.vn/Brand/1/Oppo7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:10,
                img:'https://cdn.tgdd.vn/Brand/1/Realme7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:11,
                img:'https://cdn.tgdd.vn/Brand/1/Abardeen7077-b_25.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:12,
                img:'https://cdn.tgdd.vn/Brand/1/Suunto7077-b_14.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:13,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-11.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:14,
                img:'https://cdn.tgdd.vn/Brand/1/itellogo-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content:'Dưới 1 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 1 - 2 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 4 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 4 - 7 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 10 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 10 - 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:3,
        title: 'Thời trang sành điệu',
        name:'fashion',
        dropDown: [
            {
                content:'Thời trang sành điệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Thể thao chuyên nghiệp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Định vị trẻ em',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vòng đeo tay thông minh',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:4,
        title: 'Môn thể thao',
        name:'sport-subject',
        dropDown: [
            {
                content:'Chạy bộ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bơi lộ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đạp xe',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bộ môn phối hợp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Yoga',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bóng đá',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Golf',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:5,
        title: 'Mặt đồng hồ',
        name:'face-watch',
        dropDown: [
            {
                content:'Dới 40 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'40 - 42 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'42 - 45 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 45 mm',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Chữ nhật',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vuông',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tròn',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:6,
        title: 'Thời lượng pin',
        name:'battery',
        dropDown: [
            {
                content:'Dưới 2 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 5 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 5 - 7 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 14 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 14 ngày',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:7,
        title: 'Kháng nước',
        name:'avoid-water',
        dropDown: [
            {
                content:'IP64 / 2 ATM (Rửa tay)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'IP67 / 3 ATM (Đi mưa)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'IP68 / 5 ATM (Tắm)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'5 ATM ISO 22810:2010 (Bơi)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'10 ATM (Lặn)',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:8,
        title: 'Theo dõi sức khỏe',
        name:'healthy',
        dropDown: [
            {
                content:'Đo lượng tiêu thụ oxy tối đa (VO2 max)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đo nồng độ oxy trong máu (SpO2)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tính quãng đường chạy',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tính lượng calories tiêu thụ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Theo dõi giấc ngủ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đo nhịp tim',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đếm số bước chân',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:9,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
                content:'Hỗ trợ eSIM',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Hỗ trợ SIM 4G/LTE',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nghe gọi ngay trên đồng hồ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nhận cuộc gọi bằng đồng hồ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Màn hình luôn hiển thị',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Sạc bằng năng lượng mặt trời',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Phát hiện té ngã',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nghe nhạc',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Kết nối bluetooth với tai nghe',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:10,
        title: 'Màu sắc',
        name:'color',
        dropDown: [
            {
                content:'Đen',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Hồng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Xanh dương',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trắng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đỏ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vàng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Xanh lá',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
]

export const list_box_filter_fashion = [
    {
        id:1,
        title: 'Hãng',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/Apple7077-b26-220x48.png'
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-5.png'
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14.png'
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/Garmin7077-b_13.png'
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/logo-befit-220x48-1.png'
            },
            {
                id:6,
                img:'https://cdn.tgdd.vn/Brand/1/logoamazfit-220x48-1.png'
            },
            {
                id:7,
                img:'https://cdn.tgdd.vn/Brand/1/Kidcare7077-b_5.jpg'
            },
            {
                id:8,
                img:'https://cdn.tgdd.vn/Brand/1/Masstel7077-b_57.jpg'
            },
            {
                id:9,
                img:'https://cdn.tgdd.vn/Brand/1/Oppo7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:10,
                img:'https://cdn.tgdd.vn/Brand/1/Realme7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:11,
                img:'https://cdn.tgdd.vn/Brand/1/Abardeen7077-b_25.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:12,
                img:'https://cdn.tgdd.vn/Brand/1/Suunto7077-b_14.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:13,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-11.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:14,
                img:'https://cdn.tgdd.vn/Brand/1/itellogo-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content:'Dưới 1 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 1 - 2 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 4 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 4 - 7 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 10 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 10 - 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:3,
        title: 'Thời trang sành điệu',
        name:'fashion',
        dropDown: [
            {
                content:'Thời trang sành điệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Thể thao chuyên nghiệp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Định vị trẻ em',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vòng đeo tay thông minh',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:4,
        title: 'Môn thể thao',
        name:'sport-subject',
        dropDown: [
            {
                content:'Chạy bộ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bơi lộ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đạp xe',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bộ môn phối hợp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Yoga',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Bóng đá',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Golf',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:5,
        title: 'Mặt đồng hồ',
        name:'face-watch',
        dropDown: [
            {
                content:'Dới 40 mm',
                subCateId:1,
                manufacruteId:2,
            },
            {
                content:'40 - 42 mm',
                subCateId:1,
                manufacruteId:2,
            },
            {
                content:'42 - 45 mm',
                subCateId:1,
                manufacruteId:2,
            },
            {
                content:'Trên 45 mm',
                subCateId:1,
                manufacruteId:2,
            },
            {
                content:'Chữ nhật',
                subCateId:1,
                manufacruteId:2,
            },
            {
                content:'Vuông',
                subCateId:1,
                manufacruteId:2,
            },
            {
                content:'Tròn',
                subCateId:1,
                manufacruteId:2,
            },
        ],
    },
    {
        id:6,
        title: 'Thời lượng pin',
        name:'battery',
        dropDown: [
            {
                content:'Dưới 2 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 5 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 5 - 7 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 14 ngày',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 14 ngày',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:7,
        title: 'Kháng nước',
        name:'avoid-water',
        dropDown: [
            {
                content:'IP64 / 2 ATM (Rửa tay)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'IP67 / 3 ATM (Đi mưa)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'IP68 / 5 ATM (Tắm)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'5 ATM ISO 22810:2010 (Bơi)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'10 ATM (Lặn)',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:8,
        title: 'Theo dõi sức khỏe',
        name:'healthy',
        dropDown: [
            {
                content:'Đo lượng tiêu thụ oxy tối đa (VO2 max)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đo nồng độ oxy trong máu (SpO2)',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tính quãng đường chạy',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tính lượng calories tiêu thụ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Theo dõi giấc ngủ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đo nhịp tim',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đếm số bước chân',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:9,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
                content:'Hỗ trợ eSIM',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Hỗ trợ SIM 4G/LTE',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nghe gọi ngay trên đồng hồ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nhận cuộc gọi bằng đồng hồ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Màn hình luôn hiển thị',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Sạc bằng năng lượng mặt trời',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Phát hiện té ngã',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Nghe nhạc',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Kết nối bluetooth với tai nghe',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:10,
        title: 'Màu sắc',
        name:'color',
        dropDown: [
            {
                content:'Đen',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Hồng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Xanh dương',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trắng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Đỏ',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vàng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Xanh lá',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
]
export const list_box_filter_utility = [
    {
        id:1,
        title: 'Hãng',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/Apple7077-b26-220x48.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-5.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/Garmin7077-b_13.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/logo-befit-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:6,
                img:'https://cdn.tgdd.vn/Brand/1/logoamazfit-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:7,
                img:'https://cdn.tgdd.vn/Brand/1/Kidcare7077-b_5.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:8,
                img:'https://cdn.tgdd.vn/Brand/1/Masstel7077-b_57.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:9,
                img:'https://cdn.tgdd.vn/Brand/1/Oppo7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:10,
                img:'https://cdn.tgdd.vn/Brand/1/Realme7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:11,
                img:'https://cdn.tgdd.vn/Brand/1/Abardeen7077-b_25.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:12,
                img:'https://cdn.tgdd.vn/Brand/1/Suunto7077-b_14.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:13,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-11.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:14,
                img:'https://cdn.tgdd.vn/Brand/1/itellogo-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content:'Dưới 1 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 1 - 2 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 4 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 4 - 7 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 10 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 10 - 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:3,
        title: 'Loại sản phẩm',
        name:'cate-product',
        dropDown: [
            {
                content:'Thời trang sành điệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Thể thao chuyên nghiệp',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Định vị trẻ em',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Vòng đeo tay thông minh',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:4,
        title: 'Môn thể thao',
        name:'sport-subject',
        dropDown: [
            {
                content:'Chạy bộ',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Bơi lộ',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Đạp xe',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Bộ môn phối hợp',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Yoga',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Bóng đá',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Golf',
                subCateId:1,
                menufactureId:2,
            },
        ],
    },
    {
        id:5,
        title: 'Mặt đồng hồ',
        name:'face-watch',
        dropDown: [
            {
                content:'Dới 40 mm',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'40 - 42 mm',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'42 - 45 mm',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Trên 45 mm',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Chữ nhật',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Vuông',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Tròn',
                subCateId:1,
                menufactureId:2,
            },
        ],
    },
    {
        id:6,
        title: 'Thời lượng pin',
        name:'battery',
        dropDown: [
            {
                content:'Dưới 2 ngày',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Từ 2 - 5 ngày',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Từ 5 - 7 ngày',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Từ 7 - 14 ngày',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Trên 14 ngày',
                subCateId:1,
                menufactureId:2,
            },
        ],
    },
    {
        id:7,
        title: 'Kháng nước',
        name:'avoid-water',
        dropDown: [
            {
                content:'IP64 / 2 ATM (Rửa tay)',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'IP67 / 3 ATM (Đi mưa)',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'IP68 / 5 ATM (Tắm)',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'5 ATM ISO 22810:2010 (Bơi)',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'10 ATM (Lặn)',
                subCateId:1,
                menufactureId:2,
            },
        ],
    },
    {
        id:8,
        title: 'Theo dõi sức khỏe',
        name:'healthy',
        dropDown: [
            {
                content:'Đo lượng tiêu thụ oxy tối đa (VO2 max)',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Đo nồng độ oxy trong máu (SpO2)',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Tính quãng đường chạy',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Tính lượng calories tiêu thụ',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Theo dõi giấc ngủ',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Đo nhịp tim',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Đếm số bước chân',
                subCateId:1,
                menufactureId:2,
            },
        ],
    },
    {
        id:9,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
                content:'Hỗ trợ eSIM',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Hỗ trợ SIM 4G/LTE',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Nghe gọi ngay trên đồng hồ',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Nhận cuộc gọi bằng đồng hồ',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Màn hình luôn hiển thị',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Sạc bằng năng lượng mặt trời',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Phát hiện té ngã',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Nghe nhạc',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Kết nối bluetooth với tai nghe',
                subCateId:1,
                menufactureId:2,
            },
        ],
    },
    {
        id:10,
        title: 'Màu sắc',
        name:'color',
        dropDown: [
            {
                content:'Đen',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Hồng',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Xanh dương',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Trắng',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Đỏ',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Vàng',
                subCateId:1,
                menufactureId:2,
            },
            {
                content:'Xanh lá',
                subCateId:1,
                menufactureId:2,
            },
        ],
    },
]
export const list_box_filter_sport = [
    {
        id:1,
        title: 'Hãng',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/Apple7077-b26-220x48.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-5.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/Garmin7077-b_13.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/logo-befit-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:6,
                img:'https://cdn.tgdd.vn/Brand/1/logoamazfit-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:7,
                img:'https://cdn.tgdd.vn/Brand/1/Kidcare7077-b_5.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:8,
                img:'https://cdn.tgdd.vn/Brand/1/Masstel7077-b_57.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:9,
                img:'https://cdn.tgdd.vn/Brand/1/Oppo7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:10,
                img:'https://cdn.tgdd.vn/Brand/1/Realme7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:11,
                img:'https://cdn.tgdd.vn/Brand/1/Abardeen7077-b_25.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:12,
                img:'https://cdn.tgdd.vn/Brand/1/Suunto7077-b_14.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:13,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-11.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:14,
                img:'https://cdn.tgdd.vn/Brand/1/itellogo-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content:'Dưới 1 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 1 - 2 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 2 - 4 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 4 - 7 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 7 - 10 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Từ 10 - 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Trên 15 triệu',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:3,
        title: 'Thể thao chuyên nghiệp',
        name:'profess-sport',
        dropDown: [
            {
                content:'Thời trang sành điệu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Thể thao chuyên nghiệp',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Định vị trẻ em',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Vòng đeo tay thông minh',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:4,
        title: 'Môn thể thao',
        name:'sport-subject',
        dropDown: [
            {
                content:'Chạy bộ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Bơi lộ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đạp xe',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Bộ môn phối hợp',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Yoga',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Bóng đá',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Golf',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:5,
        title: 'Mặt đồng hồ',
        name:'face-watch',
        dropDown: [
            {
                content:'Dới 40 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'40 - 42 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'42 - 45 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trên 45 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Chữ nhật',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Vuông',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Tròn',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:6,
        title: 'Thời lượng pin',
        name:'battery',
        dropDown: [
            {
                content:'Dưới 2 ngày',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 2 - 5 ngày',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 5 - 7 ngày',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 7 - 14 ngày',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trên 14 ngày',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:7,
        title: 'Kháng nước',
        name:'avoid-water',
        dropDown: [
            {
                content:'IP64 / 2 ATM (Rửa tay)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'IP67 / 3 ATM (Đi mưa)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'IP68 / 5 ATM (Tắm)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'5 ATM ISO 22810:2010 (Bơi)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'10 ATM (Lặn)',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:8,
        title: 'Theo dõi sức khỏe',
        name:'healthy',
        dropDown: [
            {
                content:'Đo lượng tiêu thụ oxy tối đa (VO2 max)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đo nồng độ oxy trong máu (SpO2)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Tính quãng đường chạy',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Tính lượng calories tiêu thụ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Theo dõi giấc ngủ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đo nhịp tim',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đếm số bước chân',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:9,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
                content:'Hỗ trợ eSIM',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Hỗ trợ SIM 4G/LTE',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Nghe gọi ngay trên đồng hồ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Nhận cuộc gọi bằng đồng hồ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Màn hình luôn hiển thị',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Sạc bằng năng lượng mặt trời',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Phát hiện té ngã',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Nghe nhạc',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Kết nối bluetooth với tai nghe',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:10,
        title: 'Màu sắc',
        name:'color-sport',
        dropDown: [
            {
                content:'Đen',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Hồng',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Xanh dương',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trắng',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đỏ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Vàng',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Xanh lá',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
]
export const list_box_filter_children = [
    {
        id:1,
        title: 'Hãng',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/Apple7077-b26-220x48.png',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-5.png',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14.png',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/Garmin7077-b_13.png',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/logo-befit-220x48-1.png',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:6,
                img:'https://cdn.tgdd.vn/Brand/1/logoamazfit-220x48-1.png',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:7,
                img:'https://cdn.tgdd.vn/Brand/1/Kidcare7077-b_5.jpg',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:8,
                img:'https://cdn.tgdd.vn/Brand/1/Masstel7077-b_57.jpg',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:9,
                img:'https://cdn.tgdd.vn/Brand/1/Oppo7077-b_28.jpg',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:10,
                img:'https://cdn.tgdd.vn/Brand/1/Realme7077-b_28.jpg',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:11,
                img:'https://cdn.tgdd.vn/Brand/1/Abardeen7077-b_25.jpg',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:12,
                img:'https://cdn.tgdd.vn/Brand/1/Suunto7077-b_14.png',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:13,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-11.png',
                subCateId:1,
                manufacrute:2,
            },
            {
                id:14,
                img:'https://cdn.tgdd.vn/Brand/1/itellogo-220x48-1.png',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content:'Dưới 1 triệu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 1 - 2 triệu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 2 - 4 triệu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 4 - 7 triệu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 7 - 10 triệu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 10 - 15 triệu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trên 15 triệu',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:3,
        title: 'Định vị trẻ em',
        name:'locate-child',
        dropDown: [
            {
                content:'Thời trang sành điệu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Thể thao chuyên nghiệp',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Định vị trẻ em',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Vòng đeo tay thông minh',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:4,
        title: 'Môn thể thao',
        name:'sport-subject',
        dropDown: [
            {
                content:'Chạy bộ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Bơi lộ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đạp xe',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Bộ môn phối hợp',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Yoga',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Bóng đá',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Golf',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:5,
        title: 'Mặt đồng hồ',
        name:'face-watch',
        dropDown: [
            {
                content:'Dới 40 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'40 - 42 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'42 - 45 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trên 45 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Chữ nhật',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Vuông',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Tròn',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:6,
        title: 'Thời lượng pin',
        name:'battery',
        dropDown: [
            {
                content:'Dưới 2 ngày',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 2 - 5 ngày',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 5 - 7 ngày',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 7 - 14 ngày',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trên 14 ngày',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:7,
        title: 'Kháng nước',
        name:'avoid-water',
        dropDown: [
            {
                content:'IP64 / 2 ATM (Rửa tay)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'IP67 / 3 ATM (Đi mưa)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'IP68 / 5 ATM (Tắm)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'5 ATM ISO 22810:2010 (Bơi)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'10 ATM (Lặn)',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:8,
        title: 'Theo dõi sức khỏe',
        name:'healthy',
        dropDown: [
            {
                content:'Đo lượng tiêu thụ oxy tối đa (VO2 max)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đo nồng độ oxy trong máu (SpO2)',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Tính quãng đường chạy',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Tính lượng calories tiêu thụ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Theo dõi giấc ngủ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đo nhịp tim',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đếm số bước chân',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:9,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
                content:'Hỗ trợ eSIM',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Hỗ trợ SIM 4G/LTE',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Nghe gọi ngay trên đồng hồ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Nhận cuộc gọi bằng đồng hồ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Màn hình luôn hiển thị',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Sạc bằng năng lượng mặt trời',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Phát hiện té ngã',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Nghe nhạc',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Kết nối bluetooth với tai nghe',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:10,
        title: 'Màu sắc',
        name:'color',
        dropDown: [
            {
                content:'Đen',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Hồng',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Xanh dương',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trắng',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đỏ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Vàng',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Xanh lá',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
]
export const list_box_filter_watchChain  = [
    {
        id:1,
        title: 'Lọai dây',
        name:'cate-strap',
        dropDown: [
            {
                content:'Dây đồng hồ thời trang',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây Apple watch',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây Oppo Watch',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây Samsung watch',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây Miband',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây Huawei watch',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:2,
        title: 'Độ rộng dây',
        name:'width-strap',
        dropDown: [
            {
                content:'12 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'14 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'16 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'18 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'20 mm',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'22 mm',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:3,
        title: 'Chất liệu dây',
        name:'material-strap',
        dropDown: [
            {
                content:'Dây da tổng hợp',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây silicone',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây nhựa TPU',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây nylon',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Dây thép không gỉ',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:4,
        title: 'Màu dây',
        name:'color-strap',
        dropDown: [
            {
                content:'Cam',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đen',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Đỏ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Hoa văn',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Hồng',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Kem',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Nâu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Phối màu',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trắng',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Xanh dương',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Xanh lá',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
    {
        id:5,
        title: 'Giá',
        name:'price-strap',
        dropDown: [
            {
                content:'Dưới 200.000đ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Từ 200.000đ - 400.000đ',
                subCateId:1,
                manufacrute:2,
            },
            {
                content:'Trê 400.000đ',
                subCateId:1,
                manufacrute:2,
            },
        ],
    },
   
]
